import { render } from "./ClauseItem.vue?vue&type=template&id=36eadc06&scoped=true"
import script from "./ClauseItem.vue?vue&type=script&lang=js"
export * from "./ClauseItem.vue?vue&type=script&lang=js"

import "./ClauseItem.vue?vue&type=style&index=0&id=36eadc06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eadc06"]])

export default __exports__